// Bracket pair colouring: each bracket takes the colour of its depth, three colours in
// turn, the way an editor does. A closer that matches nothing is flagged (b = 3). The stack
// runs from line to line, so a pair that spans a hunk is one pair.
import type { Line, Tok } from './types'

const PAIR: Record<string, string> = { '(': ')', '[': ']', '{': '}' }
const CLOSER = new Set([')', ']', '}'])

/** Colours the bracket tokens of `lines` in place; returns the openers still unclosed. */
export const colourBrackets = (lines: Line[], stack: string[] = []): string[] => {
  const open = [...stack]
  for (const line of lines) {
    for (const t of line) {
      if (t.k !== 'punct') continue
      if (t.s in PAIR) {
        t.b = open.length % 3
        open.push(t.s)
      } else if (CLOSER.has(t.s)) {
        const top = open[open.length - 1]
        if (top !== undefined && PAIR[top] === t.s) {
          open.pop()
          t.b = open.length % 3
        } else t.b = 3
      }
    }
  }
  return open
}

/** Merge neighbours that look the same, so a line is a few spans and not one per word. */
export const mergeToks = (line: Line): Tok[] => {
  const out: Tok[] = []
  for (const t of line) {
    const last = out[out.length - 1]
    // a bracket always stands alone: its colour is its own
    if (last && last.k === t.k && last.b === undefined && t.b === undefined) last.s += t.s
    else out.push({ ...t })
  }
  return out
}
